import { cursorPaginationFieldPolicy } from '../../../utils/policies/cursorPaginationFieldPolicy';
import type { TypePolicies } from '../../../utils/types/TypePolicies';

export const typePolicies: TypePolicies = {
  Account: {
    fields: {
      viewerAccountData: {
        merge: true,
      },
      image: {
        merge: true,
      },
      permissions: {
        merge: true,
      },
      notificationGroups: {
        ...cursorPaginationFieldPolicy(['accountId'], true),
      },
      quickSearch: cursorPaginationFieldPolicy(
        ['query', 'filters', 'scope'],
        false,
        (node) => node?.__ref ?? node?.id
      ),
      quickSearchNlp: cursorPaginationFieldPolicy(
        ['query', 'filters', 'scope'],
        false,
        (node) => node?.__ref ?? node?.id
      ),
      advancedSearch: cursorPaginationFieldPolicy(
        ['query', 'filters', 'orderBy'],
        false,
        (node) => node?.__ref ?? node?.id
      ),
      advancedSearchNlp: cursorPaginationFieldPolicy(
        ['query', 'filters', 'orderBy'],
        false,
        (node) => node?.__ref ?? node?.id
      ),
      quickSearchResults: cursorPaginationFieldPolicy(['$searchTerm']),
      resourceSearchResults: cursorPaginationFieldPolicy(['$searchTerm']),
      usage: {
        merge: true,
      },
      usageByLicenseType: {
        merge: true,
      },
      workspaces: cursorPaginationFieldPolicy(['filter', 'order']),
      actions: cursorPaginationFieldPolicy(['filter', 'order']),
      webhooks: cursorPaginationFieldPolicy(['order']),
      accessRequests: cursorPaginationFieldPolicy(),
    },
  },
};
